import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, catchError, first, firstValueFrom, Observable, Subject, Subscriber} from "rxjs";
import {AuthV1Service, HubUser} from "../apis/backend";
import {Router} from "@angular/router";

export const CurrentUserIsNotLoggedIn: HubUser = {};


@Injectable()
export class UserService {

    public CurrentUser = new BehaviorSubject<HubUser>(null);
    
    constructor(private _authService: AuthV1Service, private _router: Router) {
        firstValueFrom(this._authService.getCurrentUser()).then(
            (user) => {
                this.CurrentUser.next(user);
            },
            () => {
                this.CurrentUser.next(CurrentUserIsNotLoggedIn);
            });
    }

    public login(username: string, password: string) {
        let loginRequest = this._authService.login({
            Username: username,
            Password: password
        });
        return firstValueFrom(loginRequest).then(
            (user) => {
                this.CurrentUser.next(user);
                return true;
            },
            () => {
                return false;
            });
    }
    
    public logout() {
        let logoutRequest = this._authService.logout();
        firstValueFrom(logoutRequest).then(
            () => {
                this.CurrentUser.next(CurrentUserIsNotLoggedIn);
                this._router.navigate(['/login'], { queryParams: { returnUrl: this._router.url }});
            });
    }
}